import { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';

import { HotKeyTrigger } from '../hotkeys/HotKeyTrigger';

const DebugModeContext = createContext(false);

export function useDebugMode(): boolean {
  return useContext(DebugModeContext);
}

export type DebugModeProviderProps = {
  children?: ReactNode;
  on?: boolean;
  enableShortcut?: boolean;
};

export function DebugModeProvider({ children, on = false, enableShortcut }: DebugModeProviderProps) {
  const [isOn, setIsOn] = useState(on);

  return (
    <DebugModeContext.Provider value={isOn}>
      {enableShortcut && <HotKeyTrigger hotkey="ctrl+d" action={() => setIsOn((value) => !value)} />}
      {children}
    </DebugModeContext.Provider>
  );
}

export type DebugViewProps = {
  children?: ReactNode;
};

export function DebugView({ children }: DebugViewProps) {
  const debugModeOn = useDebugMode();
  return debugModeOn ? <>{children}</> : null;
}
